module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/vi/5-17acb1a438e9f639bad21291b210be81.jpg";